import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { showLoading, showLoadingUpdate } from '@app/store/actions/common.action';
import {
    HTTP_HEADERS_SKIP_LOADING,
    HTTP_HEADERS_UPDATE_LOADING,
    UPDATE_LOADING_VALUE,
} from '@constants/app.constant';
import { environment } from '@env/environment';
import { StoreModel } from '@models/store.model';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { catchError, finalize, throwError } from 'rxjs';

export const baseInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const cookieService = inject(CookieService);
    const store = inject(Store<StoreModel>);
    const userToken = cookieService.get(environment.cookieName);
    const updateLoading = req.headers.get(HTTP_HEADERS_UPDATE_LOADING);
    const skipLoading = req.headers.get(HTTP_HEADERS_SKIP_LOADING);
    const modifiedReq = req.clone({
        withCredentials: true,
        ...(userToken && {
            headers: req.headers.set('Authorization', 'Bearer ' + userToken),
        }),
    });
    const isShowLoading =
        req.url.includes(environment.apiUrl) && (!skipLoading || skipLoading !== 'skip');

    if (isShowLoading) {
        store.dispatch(showLoading({ loading: true }));
    }
    if (updateLoading === UPDATE_LOADING_VALUE) {
        store.dispatch(showLoadingUpdate({ loading: true }));
    }

    return next(modifiedReq).pipe(
        catchError((error: HttpErrorResponse) => {
            const { status } = error;
            const { pathname, search } = location;

            if (status === HttpStatusCode.Forbidden) {
                router.navigate(['/error/403-access-denied']);
            }

            if (status === HttpStatusCode.Unauthorized && !pathname.includes('/auth')) {
                router.navigate(['/auth/login'], {
                    ...(!pathname.includes('/auth') &&
                        pathname !== '/' && {
                            queryParams: { ref: pathname + search },
                        }),
                });
            }
            return throwError(() => new Error(error.message));
        }),
        finalize(() => {
            if (isShowLoading) {
                store.dispatch(showLoading({ loading: false }));
            }
            if (updateLoading === UPDATE_LOADING_VALUE) {
                store.dispatch(showLoadingUpdate({ loading: false }));
            }
        })
    );
};
